<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content">
			<template #extra-content>
				<p>
					<nuxt-link class="button" :to="localePath('meeting-form', locale)">
						{{ $t('buttonRequestPackage') }}
					</nuxt-link>
				</p>
				<p>
					<nuxt-link class="button no-fill" :to="localePath('meetingpackages', locale)">
						{{ $t('buttonReturnToOverview') }}
					</nuxt-link>
				</p>
			</template>
		</main-content>

		<section v-if="page.sideImage" class="main-content contentblocks background-light">
			<div class="row contentblock">
				<content-block
					:image="page.sideImage"
					:image-webp="page.sideImageWebp"
					:image-alt="page.sideImageAlt"
					:content="page.details"
				/>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
useRemoveGifty();
</script>

<style lang="scss">
.package-prefooter {
	padding: 50px 0;
	background: #bf702a;
	color: #fff;
}

.package-prefooter h2 {
	color: #fff;
}

.extra-image {
	width: 100%;
	max-width: 600px;
	margin: 20px auto 0;
}

.package-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: stretch;
}

.package-icon {
	width: 46%;
	background: #fff;
	padding: 40px 30px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	text-align: center;
	margin: 10px auto;
}

.package-icon i,
.package-icon svg {
	color: #bf702a;
	font-size: 66px;
	margin: 0 auto 40px;
}

.package-icon span {
	width: 100%;
	font-size: 18px;
}

@media (max-width: 920px) {
	.package-icons {
		width: 100%;
	}
}

@media (max-width: 680px) {
	.package-icon {
		padding: 30px 20px;
		width: 48%;
	}

	.package-icon i,
	.package-icon svg {
		font-size: 58px;
	}

	.package-icon span {
		font-size: 16px;
	}
}
</style>
